import { render, staticRenderFns } from "./ArrowBall.vue?vue&type=template&id=1796d312&scoped=true&"
import script from "./ArrowBall.vue?vue&type=script&lang=js&"
export * from "./ArrowBall.vue?vue&type=script&lang=js&"
import style0 from "./ArrowBall.vue?vue&type=style&index=0&id=1796d312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1796d312",
  null
  
)

export default component.exports